import { render, staticRenderFns } from "./AdminNavbar.vue?vue&type=template&id=7192fd5a&scoped=true&"
import script from "./adminNavbar.ts?vue&type=script&lang=ts&"
export * from "./adminNavbar.ts?vue&type=script&lang=ts&"
import style0 from "./AdminNavbar.vue?vue&type=style&index=0&id=7192fd5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7192fd5a",
  null
  
)

export default component.exports